// shared/data/fetchPublicProfileByUserId.js
import axios from '../config/axios';

export default async function fetchPublicProfileByUserId(token, userId) {
  try {
    const res = await axios.get(`/public-profiles/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (err) {
    if (err?.response?.status === 404) {
      const error = new Error('This user has not made a public profile visible.');
      error.code = 'public_profile_not_found';
      throw error;
    }

    const message =
      err?.response?.data?.error ||
      err?.response?.data?.message ||
      err.message ||
      'Unable to load this public profile.';

    throw new Error(message);
  }
}
